import { useMemo } from 'react';
import { mergeProjectThresholds } from '@/features/projects/utils/projectMetricThresholds';
import { useProjectByIdQuery } from './projects';
import type { ProjectMetricThresholds } from '@flowqa/shared';

export const useProjectMetricThresholds = (
  projectId: string | null,
  queryOptions?: { staleTimeMs?: number; refetchOnWindowFocus?: boolean },
): { thresholds: ProjectMetricThresholds; isLoading: boolean } => {
  const projectQuery = useProjectByIdQuery(projectId, queryOptions);
  const thresholds = useMemo(
    () => mergeProjectThresholds(projectQuery.data?.metricThresholds),
    [projectQuery.data?.metricThresholds],
  );
  return { thresholds, isLoading: projectQuery.isLoading };
};
